<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row ">
            <div class="col-sm-6">
                <h4 class="m-10 text-white">{{ currentTitle }}</h4>
            </div><!-- /.col -->
            <div class="col-md-1"></div>
            <div class="col-md-1"></div>
            <!-- <div class="col-md-2">
                <input class="form-control fill" id="period-month" v-model="date" type="month" data-form-type="date">
            </div>
            <div class="col-md-2">
                <select name="select" id="period-num" v-model="period" class="form-control fill" data-dashlane-rid="2315dd6b16e495ac" data-form-type="other">
                    <option value="1">1st Pay Period</option>
                    <option value="2">2nd Pay Period</option>
                </select>
            </div> -->
            <div class='col-md-4'>
                <div id='reportrange' class='daterange pull-right'>
                    <i class='glyphicon glyphicon-calendar fa fa-calendar'></i>&nbsp;
                    <span></span> <b class='caret'></b>
                </div>
            </div>
        </div><!-- /.row --> 
      </div><!-- /.container-fluid -->  
    </div>
</template>

<script>
    import daterangepicker from 'daterangepicker/daterangepicker.js';
    import 'daterangepicker/daterangepicker.css';
    import moment from 'moment'

    export default {
        data () {
            return {
                currentTitle: '',
                formUsers: {},
                user: '',
                date: '',
                period: '',
                // form: new Form ({
                //     user: '',
                //     date: '',
                //     period: '',
                // })
            }
        },
        methods: {
            cb(start, end) {
                $('#reportrange span').html(start.format('MMM D') + ' - ' + end.format('MMM D'));
            },
            getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");
                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, " "));
            },
            indexp(){
                var sDate = this.getParameterByName('sdate');
                var eDate = this.getParameterByName('edate');
                var name = this.getParameterByName('name');
                if( !sDate ){
                    sDate = moment().utcOffset("-05:00").format('YYYY-MM-DD');
                }
                if( !eDate ){
                    eDate = moment().utcOffset("-05:00").format('YYYY-MM-DD');
                }
                var current_start = moment().utcOffset("-05:00").startOf('month');
                var current_end = moment().utcOffset("-05:00").endOf('month');
                var prev_start = moment().utcOffset("-05:00").subtract(1, 'month').startOf('month');
                var prev_end = moment().utcOffset("-05:00").subtract(1, 'month').endOf('month');
                var half_month = 16;

                this.cb(moment( sDate ), moment( eDate ) );
                $('#reportrange').daterangepicker({
                    ranges: {
                       'Today': [moment().utcOffset("-05:00"), moment().utcOffset("-05:00")],
                       'Yesterday': [moment().utcOffset("-05:00").subtract(1, 'days'), moment().utcOffset("-05:00").subtract(1, 'days')],
                       'This Half Month': [ current_start, current_end ],
                       'Last Half Month': [prev_start,prev_end],
                       'Last 7 Days': [moment().utcOffset("-05:00").subtract(6, 'days'), moment().utcOffset("-05:00")],
                       'Last 30 Days': [moment().utcOffset("-05:00").subtract(29, 'days'), moment().utcOffset("-05:00")],
                       'This Month': [moment().utcOffset("-05:00").startOf('month'), moment().utcOffset("-05:00").endOf('month')],
                       'Last Month': [moment().utcOffset("-05:00").subtract(1, 'month').startOf('month'), moment().utcOffset("-05:00").subtract(1, 'month').endOf('month')]
                    },
                    'showDropdowns': true,
                    'locale': {
                        'firstDay': 1,
                    },
                }, this.cb);
                $('#reportrange').on('apply.daterangepicker', function(ev, picker) {    
                    var searchParams = new URLSearchParams(window.location.search);
                    searchParams.set('sdate', picker.startDate.format('YYYY-MM-DD'));
                    searchParams.set('edate',  picker.endDate.format('YYYY-MM-DD')); 
                    window.location.href = window.location.pathname + '?'+ searchParams.toString();  
                }); 
            },
            loadData() {
                axios.post("api/v1/search",
                        {
                            'page': this.$route.meta.title,
                            'user': this.user,
                            'period': this.period 
                        }
                    ).then(({ data }) => {
                    this.formUsers = data.data
                });
            },
            loadDef() {
                // var title = this.$route.path;
                // this.currentTitle = this.$route.path.split('/');
                this.currentTitle = document.title;
                // console.log('page title:', this.$route.meta.title);
            }
        },
        mounted() {
            this.indexp();
            this.loadData();
            this.loadDef();
            console.log('Filter Component mounted.')
        }
    }
</script>
